import { useEffect, useRef } from "react";
import { API } from "@/lib/api";

// One websocket per room, shared by live messages, call signaling and captions.
export function useRoomSocket(roomId, onEvent) {
  const wsRef = useRef(null);
  const handlerRef = useRef(onEvent);
  handlerRef.current = onEvent;

  useEffect(() => {
    if (!roomId) return;
    const token = localStorage.getItem("cml_token") || "";
    const url = `${API.replace(/^http/, "ws")}/ws/rooms/${roomId}?token=${encodeURIComponent(token)}`;
    let ws;
    try {
      ws = new WebSocket(url);
      wsRef.current = ws;
      ws.onmessage = (e) => {
        try {
          handlerRef.current?.(JSON.parse(e.data));
        } catch (err) {
          console.error("Room socket sent a malformed message:", err);
        }
      };
      ws.onclose = () => {
        if (wsRef.current === ws) wsRef.current = null;
      };
    } catch (err) {
      console.error("Could not open the room socket:", err);
      wsRef.current = null;
    }
    return () => {
      try {
        ws?.close();
      } catch {
        /* already closed by the browser — nothing to clean up */
      }
      wsRef.current = null;
    };
  }, [roomId]);

  const send = (payload) => {
    if (wsRef.current?.readyState === 1) wsRef.current.send(JSON.stringify(payload));
  };

  return { send, socketRef: wsRef };
}
